export class Contact {
  public FullName: string;
  public CompanyName: string;
  public Email: string;
  public Telephone: string;
  public Postcode: string;
  public EnquiryDetail: string;
  public DecisionMaker: string;
  public ContactingFor: string;
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/contact/contact.ts